/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import Error from "../../../@biocrates-common-repo/core/models/error"

export interface State {
    isVisible: boolean
    error: Error | undefined
}

export const initialState = {
    isVisible: false,
    error: undefined,
}
